'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:UserChangepasswordCtrl
 * @description
 * # UserChangepasswordCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('UserChangepasswordCtrl', function ($controller, $routeParams, $location, userService, FlashService) {

    var changePasswordVm = this;
    $controller('BaseController', {
      vm: changePasswordVm
    });
    var userId = $routeParams.userId;

    changePasswordVm.changePasswordData = {
      oldPassword: null,
      newPassword: null,
      confirmPassword: null
    };

    changePasswordVm.changePassword = changePassword;

    function changePassword(valid) {
      if (valid) {
        return changePasswordVm.requestStart()
          .then(userService.changePassword.bind(null, userId, changePasswordVm.changePasswordData))
          .then(function() {
              FlashService.Success('Password changed successfully');
              $location.path('/users');
          })
          .catch(function(error) {
              FlashService.Error(error.message);
          })
          .finally(changePasswordVm.requestComplete.bind(changePasswordVm));
      }
    }
  });
